document.addEventListener('DOMContentLoaded', function() {
  //make header sticky on scroll down
    window.addEventListener('scroll', function() {
        const header = document.querySelector('.header-sticker__inner.use-sticky');
        if (window.scrollY >= 500) {
            header.classList.add('active-custom');
        } else {
            header.classList.remove('active-custom');
        }
    });
});
